/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// # ROC Selections Module

define('modules/Product/ProductService',[
    'jquery',
    'global/all'
], function ($, Roc) {
    'use strict';
    var apiUrl = window.RocConfig.api.baseRocApiUrl;
    var products = {};

    function getById(id) {
        var deferred = $.Deferred();
        if (products[id] !== undefined) {
            Roc.Logger.info('ProductService -> getById: getting product from cache...');
            deferred.resolve(products[id]);
        } else {
            Roc.Logger.info('ProductService -> getById: getting product from the api...');
            $.ajax({
                url: apiUrl + '/api/product/' + id + '/',
                type: 'GET',
                dataType: 'json',
                contentType: 'application/json'
            }).done(function(product) {
                products[id] = product;
                deferred.resolve(product);
            }).fail(function() {
                deferred.reject();
            });
        }
        return deferred;
    }

    function getRecentlyViewedProducts(ids) {
        return $.ajax({
            url: apiUrl + '/api/product/recentlyViewedItems',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify(ids)
        });
    }

    var ProductService = {
        getById: getById,
        getRecentlyViewedProducts: getRecentlyViewedProducts,
    };

    Roc.Logger.debug('ProductService.js Loaded:', ProductService);

    return ProductService;
});
